import { canSigninWithPlatform, fetchAuthInfo, isInactiveAccountError, readOrganizationName } from './auth-info'

export interface IInactiveAccount {
  organizationName?: string
  /** The platform list is the precise answer; the error is all a deployment without it can give. */
  detectedBy: 'availablePlatforms' | 'inactiveError'
}

/**
 * Asked per platform rather than per address: an account elsewhere on the same address stays
 * live when this one is deactivated. Null while this platform can still sign in; a lookup that
 * fails for any other reason says nothing either way, so it lets the attempt through.
 */
export const findInactiveAccount = async (email: string, platform: string): Promise<IInactiveAccount | null> => {
  try {
    const info = await fetchAuthInfo(email)
    return canSigninWithPlatform(info, platform) ? null : { detectedBy: 'availablePlatforms' }
  } catch (error) {
    return isInactiveAccountError(error) ? { detectedBy: 'inactiveError', organizationName: readOrganizationName(error) } : null
  }
}
